import React, { Component } from 'react';
import Block from "./block";
import Page from '../page';

export default class Index extends Component {
  render() {
    return (
      <div>
        <Page.Header leftSide={<Page.NewButton title="Add county" name="County"/>}>
          Counties
        </Page.Header>

        <Block
          title="County"
          path="/admin/counties"
          name="County"
        />
      </div>
    );
  }
}
